export const surgicalAttendanceStatusOptions: ReactSelectOption[] = [
	{ value: "0", label: "Em processo pré-operatório" },
	{ value: "1", label: "Aguardando admissão" },
	{ value: "2", label: "Admitido" },
	{ value: "3", label: "Em processo operatório" },
	{ value: "4", label: "Em processo pós-operatório" },
	{ value: "5", label: "Alta da hospitalização" },
	{ value: "6", label: "Completo" },
];
